import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as people from '../../../../people'
import * as employee from '../employee'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: employee.RESOURCE.payload.dimension.partialId,
      partialId: employee.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Basic information about the employee',
    isOptional: false,
    name: 'Person',
    partialId: PartialId.Standard.create('person'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(people.RESOURCE.payload),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
